import React from 'react';

import { formatDateString } from '~libs/dayjs';
import { BUDGET_TERMS } from '~support-at-home/lib/budgetTerms';

import { TrackerHcpUnspentFunds } from '~support-at-home/models';

import SectionInfo from './SectionInfo';
import WholeMoney from './WholeMoney';

interface ComponentProps {
  /** Unique within the page: the info icon's id. */
  id: string;
  /** The client's Commonwealth unspent funds budget; null or undefined when there is none, so nothing is shown. */
  funds: TrackerHcpUnspentFunds | null | undefined;
  dataCy: string;
}

const LABEL = 'HCP unspent funds';

/**
 * The client's Commonwealth unspent funds, top right of the Budget Tracker (TAV-3482): available, used, total and when
 * they were last updated, as on the budget edit. For reference only: the info icon says so, and no figure uses it.
 */
const HcpUnspentFunds: React.FC<ComponentProps> = ({ id, funds, dataCy }) => {
  if (!funds) return null;

  return (
    <div className="figure-hcp-balance" data-cy={dataCy}>
      <span className="figure-hcp-balance-title">
        {LABEL}
        <SectionInfo id={id} label={LABEL} content={BUDGET_TERMS.hcp.referenceOnly} />
      </span>
      <span className="figure-hcp-balance-detail" data-cy={`${dataCy}-detail`}>
        Available <WholeMoney value={funds.available_amount} />
        {' · '}
        Used <WholeMoney value={funds.used_amount} />
        {' · '}
        Total <WholeMoney value={funds.total_amount} />
      </span>
      <span className="figure-hcp-balance-detail" data-cy={`${dataCy}-updated`}>
        Updated: {formatDateString(funds.updated_at)}
      </span>
    </div>
  );
};

export default HcpUnspentFunds;
